document.addEventListener('DOMContentLoaded', function () {
	const fixedButton = document.getElementById('fixed-button');

	if (fixedButton) {
		setTimeout(function () {
			fixedButton.classList.remove('expanded');
		}, 3000);
	}
});
